<template>
    <v-row no-gutters>
        <v-col cols="12" class="px-4 pt-4">
            <v-row no-gutters justify="space-between">
                <span class="header-text">{{ $t('message.adminPage.status.status') }}</span>

                <v-btn small color="#EBEAEB">
                    <v-icon small left :color="getStatusState?.color">{{
                        getStatusState?.icon
                    }}</v-icon>
                    <span class="default-text-prompt">{{
                        getStatusState?.text
                    }}</span>
                </v-btn>
            </v-row>
        </v-col>
        <v-col
            cols="12"
            v-if="getStatusState?.value != 'failed'"
            class="px-4 pb-4"
        >
            <v-row
                no-gutters
                class="my-3"
                v-if="applicantInfo?.registrationStatus != 'NOT_QUALIFY'"
            >
                <v-divider></v-divider>
            </v-row>
            <!-- STEP 5 -->
            <v-row no-gutters class="mb-2" v-if="currentStep == 5">
                <v-col cols="12" class="mb-2">
                    <v-row no-gutters>
                        <v-icon color="#255D98">mdi-information</v-icon>
                        <span class="default-text pl-2">{{ $t('message.adminPage.status.step3.header') }}</span>
                    </v-row>
                </v-col>
                <v-col cols="12">
                    <ul>
                        <li>{{ $t('message.adminPage.status.step3.content1') }}</li>
                        <li>
                            <span>{{$t('message.adminPage.status.step3.content2')}} </span
                            ><br/><span class="link-text" @click="routeToQualified"
                                >{{ $t('message.adminPage.status.step3.link') }}</span
                            >
                        </li>
                    </ul>
                </v-col>
            </v-row>
            <!-- STEP 3,4 -->
            <v-row
                v-else-if="applicantInfo?.registrationStatus != 'NOT_QUALIFY'"
            >
                <v-col cols="12" class="mb-3">
                    <v-row no-gutters
                        ><span class="caption-text">
                            {{ $t('message.adminPage.status.deadlineFirstRound') }}</span
                        >
                    </v-row>
                    <v-row no-gutters
                        ><span class="default-text">{{
                            announcementExamResultDeadlineDate
                        }}</span>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                    <v-row no-gutters
                        ><span class="caption-text">
                            {{ $t('message.adminPage.status.deadlineReserveRound') }}</span
                        >
                    </v-row>
                    <v-row no-gutters
                        ><span class="default-text">{{
                            reservedAnnouncementExamResultDeadlineDate
                        }}</span>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                    <v-row no-gutters
                        ><span class="caption-text"> {{ $t('message.adminPage.status.initiationDay') }}</span>
                    </v-row>
                    <v-row no-gutters
                        ><span class="default-text">{{ enrollmentDate }}</span>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mt-4">
                    <v-btn
                        :disabled="disabledRules || waitEnrollmentDate"
                        width="100%"
                        rounded
                        color="primary"
                        class="default-text-prompt"
                        @click="onConfirmStatus"
                    >
                    {{ $t('message.adminPage.status.initiationComplete') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { RegistrationStatusEnum } from "@/constants";
import i18n from "@/i18n";
import { formatDateTimeLocale } from "@/utils/date";
import dayjs from "dayjs";

export default {
    props: {
        applicantInfo: Object,
        getStatusState: Object,
        getButtonState: Object,
        currentStep: String,
    },
    mounted() {
        this.retrievedData();
    },
    computed: {
        locale() {
            return i18n.locale;
        },
        disabledRules() {
            if (
                [
                    RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL,
                ].includes(this.applicantInfo?.registrationStatus)
            )
                return false;
            return true;
        },
        announcementExamResultDeadlineDate() {
            let newDate = Date.parse(
                this.applicant?.register_form
                    ?.announcement_exam_result_deadline_date
            );
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        reservedAnnouncementExamResultDeadlineDate() {
            let newDate = Date.parse(
                this.applicant?.register_form
                    ?.reserved_announcement_exam_result_deadline_date
            );
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        enrollmentDate() {
            let newDate = Date.parse(
                this.applicant?.register_form?.enrollment_date
            );
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        waitEnrollmentDate() {
            let enrollmentDate = new Date(
                this.applicant?.register_form?.enrollment_date
            )
            enrollmentDate = enrollmentDate.setHours(0);
            if (dayjs(new Date()).isSameOrBefore(dayjs(enrollmentDate))) {
                return true;
            }
            return false;
        },
    },
    data() {
        return {
            applicant: {},
            listInfo2:
                i18n.t('message.adminPage.status.step3.content2')+"<br/>",
        };
    },
    methods: {
        retrievedData() {
            let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
            this.applicant = applicant;
        },
        onConfirmStatus() {
            this.$emit("onConfirmStatus", "confirm_enrollment");
        },
        routeToQualified() {
            this.$router.push(`/registration/qualified`);
        },
    },
};
</script>

<style scoped lang="scss">
.link-text {
    color: #ff9800;
    font-family: "Sarabun";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    text-decoration: underline;
    cursor: pointer;
}

.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text-prompt {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 10px 10px 10px 10px;
}
</style>
